import { AppMedError } from '../error/AppMedError.ts';

const MOBILE_ERROR_MESSAGES: Record<string, string> = {
    MobileRequired: 'formError.mobileIsRequired',
    InvalidMobile: 'formError.invalidMobile',
    MobileAlreadyUsed: 'formError.mobileAlreadyUsed',
};

/** The translation key of a refused mobile number, or undefined when the error is about something else. */
export const mobileErrorKeyOf = (error: unknown): string | undefined =>
    error instanceof AppMedError && error.errorCode ? MOBILE_ERROR_MESSAGES[error.errorCode] : undefined;
